export default {
  bookMenu: [
    {
      name: 'desks',
      route: '/desk4me/desk/booking',
      icon: 'desktop_mac',
      validateFeature: true
    },
    {
      name: 'team',
      route: '/desk4me/desk/team/booking',
      icon: 'groups',
      validateFeature: true
    },
    {
      name: 'rooms',
      route: '/freeroom/room/booking',
      icon: 'meeting_room',
      validateFeature: true
    },
    {
      name: 'roomNow',
      route: '/freeroom/room/booking/now',
      icon: 'av_timer',
      validateFeature: true
    },
    {
      name: 'charteredBuses',
      route: '/desk4me/chartered/booking',
      icon: 'directions_bus',
      validateFeature: true
    },
    {
      name: 'restaurant',
      route: '/desk4me/restaurant/booking',
      icon: 'restaurant',
      validateFeature: true
    },
    {
      name: 'lockers',
      route: '/desk4me/locker/booking',
      icon: 'lock',
      validateFeature: true
    },
    {
      name: 'parking',
      route: '/desk4me/parking/booking',
      icon: 'local_parking',
      validateFeature: true
    }
  ],
  npsJourney: {
    'room': 1,
    'desk': 2,
    'restaurant': 3,
    'parking': 4,
    'charteredBus': 5,
    'locker': 6
  }
}
